import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';
import { useParams } from 'react-router-dom';

import { checkPermissions } from '../store/actions/checkPermissions';
import NoMatchContainer from '../containers/pages/NoMatchContainer';
import { PERMISSION_STATUS } from '../constants/permissions';
import { reportBusinessActionToMixpanel } from '../utils/reportBusinessActionToMixpanel';
import { SUPPLIER } from '../constants/roles';
import Spinner from '../components/common/Spinner';
import { ServerErrorContainer } from '../containers/pages/ServerErrorContainer';

export default function SupplierPermissionsRequiredHOCWrapper(ComposedComponent, checkAdmin = false) {
  function SupplierPermissionsRequiredHOC(props) {
    const dispatch = useDispatch();
    const mixpanel = useMixpanel();
    const { supplierId } = useParams();
    const { isLoading = true, status = null } = useSelector((state) => state.checkPermissions);

    useEffect(() => {
      const reportToMixpanel = (params) => {
        params.href ||= window.location.href;
        reportBusinessActionToMixpanel(mixpanel, 'page-not-found-denied-permission', { params });
      };

      dispatch(checkPermissions(SUPPLIER, Number(supplierId), checkAdmin, reportToMixpanel));
      // eslint-disable-next-line
    }, []);

    if (status === PERMISSION_STATUS.DENIED) {
      return <NoMatchContainer />;
    }

    if (status === PERMISSION_STATUS.SERVER_ERROR) {
      return <ServerErrorContainer />;
    }

    if (isLoading) {
      return <Spinner />;
    }

    return <ComposedComponent {...props} />;
  }

  return SupplierPermissionsRequiredHOC;
}
